import { customerPortal } from "@vilocnv/allsetra-core";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import postGeozoneAction from "../actions/post-geozone.action";

type GeozonesState = customerPortal.geozones.GeozonesState;

const postGeozoneCases = (builder: ActionReducerMapBuilder<GeozonesState>) => {
  builder.addCase(postGeozoneAction.pending, (state) => {
    state.isLoadingGeozones = true;
  });
  builder.addCase(postGeozoneAction.fulfilled, (state) => {
    state.isLoadingGeozones = false;
  });
  builder.addCase(postGeozoneAction.rejected, (state) => {
    state.isLoadingGeozones = false;
  });
};

export default postGeozoneCases;
